import { FC, useContext, useEffect } from 'react';

import {
  ColSize,
  ContentSection,
  RowSize,
  SelectForm,
} from '../../../../../../../../../shared/components';
import { CoveragesCommerceSection } from '../CoverageCommerceSection';

import { StepFourFormContext } from '../../contexts/StepFourForm';
import { StepThreeFormContext } from '../../../StepThree/contexts/StepThreeForm';

interface CommerceQuotationFormByTabProps {
  tabKey: number;
}

export const CommerceQuotationFormByTab: FC<
  CommerceQuotationFormByTabProps
> = ({ tabKey }) => {
  const { plansByActivityList, stepThreeForm } =
    useContext(StepThreeFormContext);
  const { stepFourCommerceQuotationForm } = useContext(StepFourFormContext);

  const planSelected = stepThreeForm?.getFieldValue(`plan-tab-${tabKey}`);

  const setPlanIfSelected = () => {
    if (planSelected) {
      stepFourCommerceQuotationForm.setFieldValue(
        `plan-tab-${tabKey}`,
        planSelected
      );
    }
  };

  useEffect(() => {
    setPlanIfSelected();
  }, [planSelected, stepFourCommerceQuotationForm, tabKey]);

  return (
    <div className='mt-1'>
      <ContentSection level='h3' title='Planes'>
        <RowSize>
          <ColSize size={25}>
            <SelectForm
              formProps={{
                label: 'Lista de Planes:',
                name: `plan-tab-${tabKey}`,
              }}
              selectProps={{
                disabled: true,
                options: plansByActivityList,
              }}
            />
          </ColSize>
        </RowSize>
      </ContentSection>

      <CoveragesCommerceSection tabKey={tabKey} />
    </div>
  );
};
